let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '角色名称',
        props: 'roleName',
        minWidth: 200,
    },
    {
        label: '角色描述',
        props: 'described',
        minWidth: 300,
        tooltip:true,
    }
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '系统管理'
},
{
    type: 'title',
    name: '角色管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'roleId',
    editRouter: 'roleManageDetail',
};

// 路由
pageConfig.listRouter = 'role_list';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '角色管理',
    router: 'role_list'
},
{
    type: 'title',
    name: '新增',
}];

pageConfig.formRules = {
    roleName: [{
        required: true,
        message: '请填写角色名称',
        trigger: 'blur'
    }],
    described: [{
        required: true,
        message: '请填写角色描述',
        trigger: 'blur'
    }],
};



export default pageConfig;